import React from 'react';
import styles from './CreditMiniView.module.scss';

export interface CreditMiniViewProps {
  creditValue: number | undefined;
  formattedCredit: string;
  creditStatus: 'ok' | 'warning' | 'danger';
  deviceId?: string;
  creditTime?: string;
}

export default function CreditMiniView({
  creditValue,
  formattedCredit,
  creditStatus,
  deviceId,
  creditTime
}: CreditMiniViewProps) {
  const getStatusColor = () => {
    // Si c'est "NA", retourner gris très clair
    if (formattedCredit === 'NA') {
      return '#d1d5db'; // Gris très clair
    }
    
    switch (creditStatus) {
      case 'ok':
        return '#059669'; // Vert
      case 'warning':
      case 'danger':
        return '#dc2626'; // Rouge
      default:
        return '#059669';
    }
  };

  const statusColor = getStatusColor();
  const isNA = formattedCredit === 'NA';
  
  // Construire le tooltip avec les informations disponibles
  const tooltipText = [
    deviceId && `ID: ${deviceId}`,
    `Crédit restant: ${formattedCredit}${isNA ? '' : ' kWh'}`,
    creditTime && `Capturé le: ${new Date(creditTime).toLocaleString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })}`
  ].filter(Boolean).join('\n');

  return (
    <div className={styles.creditMini} title={tooltipText || undefined}>
      <span className={styles.creditValue} style={{ color: statusColor }}>
        {formattedCredit}
      </span>
      {!isNA && (
        <span className={styles.creditUnit} style={{ color: statusColor }}>
          {' '}kWh
        </span>
      )}
    </div>
  );
}

